<template>
  <section>
    <z-dialog :show="isVisible" :modal-size="modalSize">
      <template #header>
        <div class="row custom-header">
          <div class="col-11">
            <h4 class="modal-title">
              {{ title }}
            </h4>
          </div>
          <div class="col-1">
            <a href="#" class="custom-close" @click="close">
              <i class="fa fa-times"></i>
            </a>
          </div>
        </div>
      </template>
      <template #body>
        <div class="custom-body">
          <div class="row">
            <div class="col-3">
              <label for="queries">Query:</label>
              <select id="queries" v-model="queryStringNeo" class="form-control">
                <option v-for="item of savedNEOqueries" :key="item.id" :value="item.value">
                  <span>{{ item.name }}</span>
                </option>
              </select>
            </div>
            <div class="col">
              <div class="row">
                <div class="col">
                  <span>JSPath query (can be refined as necessary):</span>
                  <textarea v-model="queryStringNeo" class="form-control custom-query-string" />
                </div>
                <div class="col">
                  <button class="btn btn-primary btn-sm custom-query-button" @click="queryNeo">
                    <i v-if="isQueryingNeo" class="fas fa-spinner fa-spin mr-2"></i>query
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col custom-query-results">
              <div v-show="loading?.decodedVin" class="custom-loading">
                <i class="fas fa-spinner fa-spin"></i>
                <span>Loading...</span>
              </div>
              <json-viewer :value="evaluation2" copyable />
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="custom-footer">
          <div class="col-9">
            <a href="https://github.com/dfilatov/jspath" target="_blank">JSPath Query Expressions</a>
          </div>
          <div class="col-3 custom-right-align">
            <button type="button" class="btn btn-light" @click="close()">Close</button>
          </div>
        </div>
      </template>
    </z-dialog>
  </section>
</template>
<script>
import { mapState } from 'pinia'
import { adasmatrixStore } from '@/stores/adasmatrix'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import { JsonViewer } from 'vue3-json-viewer'
import 'vue3-json-viewer/dist/index.css'
import JSPath from 'jspath'

export default {
  name: 'DialogVinDecodeCompare',
  components: {
    ZDialog,
    JsonViewer
  },
  props: {
    modelValue: Object
  },
  data() {
    return {
      modalSize: 'modal-lg',
      queryStringNeo: null,
      evaluation2: [],
      isQueryingNeo: false,
      savedNEOqueries: [
        {
          id: 0,
          name: 'Installed Equipment',
          value: '.installed_equipment{.category === "Safety & Driver Assist"}'
        },
        {
          id: 1,
          name: 'Safety & Driver Assist',
          value: '.installed_equipment{.category ^= "Safety"}'
        },
        {
          id: 2,
          name: 'Comfort and Convenience',
          value: '.installed_equipment{.category ^= "Comfort"}'
        },
        {
          id: 3,
          name: 'Infotainment, Telematics',
          value: '.installed_equipment{.category ^= "Infotainment" && .item *= "telematics"}'
        },
        {
          id: 5,
          name: 'Doors, Mirrors/Cameras',
          value: '.installed_equipment{.category ^= "Exterior" && .item *= "Cameras"}'
        },
        {
          id: 6,
          name: 'Interior, Seating',
          value: '.installed_equipment{.category ^= "Interior" && (.item *= "Seating"}'
        },
        {
          id: 7,
          name: 'Interior, Steering Wheel',
          value: '.installed_equipment{.category ^= "Interior" && .item *= "Steering"}'
        }
      ]
    }
  },
  emits: ['input', 'closing'],
  computed: {
    ...mapState(adasmatrixStore, ['loading', 'decodedVin']),
    isVisible() {
      return this.modelValue !== null
    },
    title() {
      return 'Vin Decode Comparison'
    }
  },
  methods: {
    close() {
      this.$emit('closing')
    },
    queryNeo() {
      this.isQueryingNeo = false
      console.log('Querying NEO', this.queryStringNeo)
      this.evaluation2 = []
      if (this.queryStringNeo) {
        if (this.queryStringNeo.trim() !== '') {
          this.isQueryingNeo = true
          const results = JSPath.apply(this.queryStringNeo.trim(), this.decodedVin)
          // console.log('Finished NEO JSONPath', results)
          this.evaluation2 = results
          this.isQueryingNeo = false
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-close {
  float: right;
  margin-right: 10px;
  color: #000;
  cursor: pointer;
}
.custom-body {
  max-height: 600px;
  overflow-x: hidden;
  overflow-y: auto;
}
.custom-footer {
  width: 100%;
  display: inline-flex;
}
.custom-right-align {
  text-align: right;
}
.custom-query {
  display: inline-flex;
  input {
    width: 380px;
  }
}
.custom-query-results {
  max-height: 490px;
  overflow-x: hidden;
  overflow-y: auto;
}
.custom-query-string {
  width: 480px;
  margin-right: 5px;
}
.custom-query-button {
  position: absolute;
  bottom: 0;
}
</style>
